import { render, staticRenderFns } from "./PurchaseSummary.vue?vue&type=template&id=a824a654&scoped=true&"
import script from "./PurchaseSummary.vue?vue&type=script&lang=js&"
export * from "./PurchaseSummary.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseSummary.vue?vue&type=style&index=0&id=a824a654&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a824a654",
  null
  
)

export default component.exports